import React, { Component } from 'react'
import team from '../images/team.png'
import './Legend.css'

export default class Legend extends Component {

  render() {

    const { fetchedObjectives, loading } = this.props

    return (
      <div>
        { loading
          ? <h4>Loading...</h4>
          : ( <div>
              { fetchedObjectives
                .map(objective => {
                  const objectiveHeader = Object.keys(objective)[0]
                  const objectiveValue = objective[objectiveHeader]
                  return (
                    <div key={objectiveHeader} className="legendSection">
                      <h2>{objectiveHeader}</h2>
                      <table>
                        <tbody>
                          {objectiveValue.map(objectiveKey => (
                            <tr key={objectiveKey.key} className="checklistItem">
                              <td>
                                <label htmlFor={objectiveKey.key}>
                                  <td><h3>{objectiveKey.key}: </h3></td>
                                  <td><h3>{objectiveKey.objective}</h3></td>
                                  <td>
                                    {objectiveKey.type === 'team' ? (
                                      <img src={team} alt="" />
                                    ) : (
                                      <p />
                                    )}
                                  </td>
                                </label>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )
                })
              }
              </div>
            )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Legend.js